module.exports = __webpack_public_path__ + "media/images/banners/5-9a53a2bd69dd402776173160289c17ca.jpg";